import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { ClimaProgramService } from '~/api/services/climaProgram'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface DeletePurchaseModalProps {
  purchaseId: number | null
  onClose: () => void
  onSuccess: () => void
}

const DeletePurchaseModal: React.FC<DeletePurchaseModalProps> = ({ purchaseId, onClose, onSuccess }) => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)

  async function handleConfirm() {
    setIsBusy(true)
    try {
      await ClimaProgramService.deletePurchase(purchaseId)
      notify(t('Feed purchase deleted successfully'), 'success')
      onSuccess()
      onClose()
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return (
    <Dialog
      type='abort'
      textHeader={t('Delete feed purchase')}
      textContent={t('Do you really want to delete the feed purchase?')}
      isDialogOpen={Boolean(purchaseId)}
      handleClose={onClose}
      handleSubmit={handleConfirm}
      textSubmit={t('Yes')}
      textClose={t('Cancel')}
      isLoading={isBusy}
    />
  )
}

export default DeletePurchaseModal
